/**
 * Name of the window the engine is waiting on. `none` when the turn player
 * can act freely.
 */
export function duelPendingKind(state: {
  pendingPriority: unknown
  pendingTargets: unknown
  pendingFlipEffect: unknown
  pendingDiscard: unknown
  pendingCoinCall: unknown
  pendingChoice: unknown
  pendingChainOrder: unknown
  pendingOfferingSummon: unknown
}): string {
  if (state.pendingPriority) return 'priority'
  if (state.pendingTargets) return 'targets'
  if (state.pendingFlipEffect) return 'flip'
  if (state.pendingDiscard) return 'discard'
  if (state.pendingCoinCall) return 'coin'
  if (state.pendingChoice) return 'choice'
  if (state.pendingChainOrder) return 'chain'
  if (state.pendingOfferingSummon !== null && state.pendingOfferingSummon !== undefined) {
    return 'offering'
  }
  return 'none'
}
